import { useEffect, useState } from 'react'
import { api } from '../lib/api'

export function GuideSyncControl({ updated }: { updated: () => void }) {
  const [busy,setBusy]=useState(false),[message,setMessage]=useState(''),[latest,setLatest]=useState<Awaited<ReturnType<typeof api.guide.latestSync>>>(null)
  useEffect(()=>{void api.guide.latestSync().then(setLatest).catch(()=>{})},[])
  const sync=async()=>{
    setBusy(true);setMessage('正在读取公开商品，请稍候…')
    try{
      const result=await api.guide.sync()
      setMessage(result.status==='success'?`已更新 ${result.count} 件商品，人工替换保持不变。`:`已更新 ${result.count} 件；失败分类保留旧数据。${result.errors.join('；')}`)
      updated();setLatest(await api.guide.latestSync())
    }catch(error){setMessage(error instanceof Error?error.message:'更新失败，保留旧数据')}
    finally{setBusy(false)}
  }
  return <section className="guide-sync-control">
    <strong>商品云端更新</strong>
    <p>每天北京时间 10:00 更新精选和热榜，各40件。无需开电脑；人工替换不会被覆盖。</p>
    {latest&&<p>最近采集：{latest.completed_at?new Date(latest.completed_at).toLocaleString('zh-CN',{timeZone:'Asia/Shanghai'}):'进行中'} · {{success:'成功',partial:'部分成功',failed:'失败',running:'进行中'}[latest.status]??latest.status}</p>}
    <button type="button" disabled={busy} onClick={()=>void sync()}>{busy?'采集中…':'立即重新采集'}</button>
    {message&&<p role="status">{message}</p>}
  </section>
}
